<div class="sk-cms-file-detail-pc  sk-cms-file-get"
 style="{{style.background.model == 'default' ? '': 'background-color:' + style.background.color}};"
>
  {{if style.titleStyle.model != 'hide'}}
  <div class="file-title {{style.titleStyle.model == 'default'?'':style.titleStyle.fontSize2}}"
  style="{{style.titleStyle.model == 'default' ? '': 'color:' + style.titleStyle.color}};{{style.lineStyle.model == 'default' ? '': 'border-bottom-color:' + style.lineStyle.color}};{{style.lineStyle.model == 'default' ? '': 'border-bottom-style:' + style.lineStyle.line}};{{style.lineStyle.model == 'hide' ? 'border-bottom:none':''}};"
  {{(isDesign || isPreview) ? 'sk-html=$data.title' : ''}} cms-not-replace>
  {{content.title}}</div>
  {{/if}}

  <div style="display: none" id="file-title">{{content.title}}</div>

  {{if style.infoDate.model != 'hide'}}
  <div class="file-data {{style.infoDate.model == 'default'?'':style.infoDate.fontSize2}}"
  style="{{style.infoDate.model == 'default' ? '': 'color:' + style.infoDate.color}};"
  >
    <span class="smarket icons-time"
    style="{{style.infoDate.model == 'default' ? '': 'color:' + style.infoDate.iconColor}};"
    ></span> <span
    {{(isDesign || isPreview) ? 'sk-html=$data.time' : ''}} cms-not-replace
  >{{content.time}}</span>

    <span class="smarket icons-eye"
    style="{{style.infoDate.model == 'default' ? '': 'color:' + style.infoDate.iconColor}};"
    ></span> <span
    {{(isDesign || isPreview) ? 'sk-html=$data.preview' : ''}} cms-not-replace
    >{{content.statInfo.previewCount}}</span>

    <span class="smarket icons-download"
    style="{{style.infoDate.model == 'default' ? '': 'color:' + style.infoDate.iconColor}};"
    ></span> <span
    {{(isDesign || isPreview) ? 'sk-html=$data.down' : ''}} cms-not-replace
    >{{content.statInfo.downloadCount}}</span>

    <span class="smarket icons-folder"
    style="{{style.infoDate.model == 'default' ? '': 'color:' + style.infoDate.iconColor}};"
    ></span> <span
    {{(isDesign || isPreview) ? 'sk-html=$data.size' : ''}} cms-not-replace
    >{{content.sizeFormat}}</span>

  </div>
  {{/if}}

{{if style.textStyle.model != 'hide'}}
<div class="file-content"
style="{{style.textStyle.model == 'default' ? '': 'color:' + style.textStyle.color}};"
     {{(isDesign || isPreview) ? 'sk-html=$data.body' : ''}} cms-not-replace>

        {{#content.preview.show}}

</div>
{{/if}}

{{if style.recommend.model != 'hide'}}
{{if isDesign || isPreview}}
<div class="recommend-title"
  style="{{style.recommend.model == 'default' ? '': 'color:' + style.recommend.color2}};"
><span class="before"
  style="{{style.recommend.model == 'default' ? '': 'background-color:' + style.recommend.color}};"
></span>{{content.recommend}}
</div>
  <div class="recommend-list">

  </div>

{{else}}
<div class="recommend-title"
  style="{{style.recommend.model == 'default' ? '': 'color:' + style.recommend.color2}};"
><span class="before"
     style="{{style.recommend.model == 'default' ? '': 'background-color:' + style.recommend.color}}"
></span>{{content && content.recommend?content.recommend:systemContent.recommend}}
</div>
  <div class="recommend-list">
    {{each content.recommendList}}
    <div class="item"
         style="{{style.recommend.model == 'default' ? '': 'border-bottom-color:' + style.recommend.color4}}"
    >
      <div class="list-dot">
        <span class="dot1"
              style="{{style.recommend.model == 'default' ? '': 'background-color:' + style.recommend.color}}"
        ></span>
        <span class="dot2"
              style="{{style.recommend.model == 'default' ? '': 'background-color:' + style.recommend.color}}"
        ></span>
        <span class="dot3"
              style="{{style.recommend.model == 'default' ? '': 'background-color:' + style.recommend.color}}"
        ></span>
        <span class="dot4"
              style="{{style.recommend.model == 'default' ? '': 'background-color:' + style.recommend.color}}"
        ></span>
      </div>
      <a href="{{$value.link}}" class="title"
         style="{{style.recommend.model == 'default' ? '': 'color:' + style.recommend.color3}};"
      >{{$value.name}}</a>
    </div>
    {{/each}}
  </div>

{{/if}}
{{/if}}

<div id="down-box" class="down-box">
  <div class="m-box">
    <div class="title">文件下载</div>
    <div class="row">
      <span>邮箱</span>
      <input id="down-email" type="text">
    </div>
    <div id="#error" class="error"></div>
    <div class="foot">
      <div class="foot-button" sk-event.click='hide()'>取消</div>
      <div class="foot-button" sk-event.click='send()'>确定</div>
    </div>
  </div>
</div>



<!--{{if style.perviewButton.styleType != 'hide' || style.downButton.styleType != 'hide'}}-->
<!--<div class="file-detail-bottom-bar"-->
<!--style="{{style.BarBackground.model == 'default' ? '': 'background-color:' + style.BarBackground.color}};"-->
<!--&gt;-->
  <!--{{if style.perviewButton.styleType != 'hide'}}-->
  <!--<div class="button preview {{style.perviewButton.model == 'default'?'medium':style.perviewButton.fontSize}}"-->
    <!--style="{{style.perviewButton.styleType == 'default' ? '': 'color:' + style.perviewButton.color}};{{style.perviewButton.styleType == 'default' ? '': 'background-color:' + style.perviewButton.backgroundColor}};{{'background-image: url(' + style.perviewButton.imgUrl + ')'}};{{style.downButton.styleType == 'hide' ? 'width: 100%' : ''}};"-->
  <!--&gt;<a href="{{content.wapPreviewUrl?content.wapPreviewUrl:'javascript:void(0)'}}">{{content && content.perviewButton?content.perviewButton:systemContent.perviewButton}}</a></div>-->
  <!--{{/if}}-->
  <!--{{if style.downButton.styleType != 'hide'}}-->
  <!--<div class="button {{style.downButton.model == 'default'?'medium':style.downButton.fontSize}}"-->
   <!--style="{{style.downButton.styleType == 'default' ? '': 'color:' + style.downButton.color}};{{style.downButton.styleType == 'default' ? '': 'background-color:' + style.downButton.backgroundColor}};{{'background-image: url(' + style.downButton.imgUrl + ')'}};{{style.perviewButton.styleType == 'hide' ? 'width: 100%' : ''}};"-->
    <!--sk-event.click='downLoad()'>{{content && content.downloadButton?content.downloadButton:systemContent.downloadButton}}</div>-->
  <!--{{/if}}-->
<!--</div>-->
<!--{{/if}}-->
</div>